import IService from '../IService';
import app from 'app';

class JobCarrier extends Backbone.Model {
  // noinspection JSMethodCanBeStatic
  get idAttribute() {
    return 'cdnUrl';
  }

  constructor(raw, options) {
    super();
    this.story = options.story;
    this.time = {
      start: null,
      finish: null,
      passed: function () {
        return Date.now() - this.start;
      },
    };
    this._deferred = null;
  }

  start() {
    this.time.start = Date.now();
    this.time.finish = null;
    this._deferred = $.Deferred();
  }

  markFailed(how) {
    this.time.finish = Date.now();
    this._deferred.reject(how);
    this.trigger('fullPreviewFailed', how);
  }

  markFinished() {
    this.time.finish = Date.now();
    this.reportFinish();
    this._deferred.resolve(this.get('cdnUrl'));
    // rich event name is intentional
    this.trigger('fullPreviewFinished');
  }

  get isDone() {
    return 'resolved' === this._deferred.state();
  }

  get execution() {
    return this._deferred.promise();
  }

  get firebasePath() {
    return {
      parts: `/users/${app.rootStore.getters['user/id']}/stories/${
        this.story.id
      }/preview_parts/${this.get('previewId')}/parts`,
      final: `/users/${app.rootStore.getters['user/id']}/stories/${
        this.story.id
      }/previews/${this.get('previewId')}`,
    };
  }

  listenToUpdates() {
    const timeout = new app.namespace.Util.Timer(() => {
      this.markFailed('firebase timeout');
    }, 5 * app.TIME.MINUTE);
    timeout.start();

    console.log(
      'listen to full preview parts',
      `https://wochit-test.firebaseio.com/${this.firebasePath.parts}`
    );

    app.api.realTime.listenOn({
      path: this.firebasePath.parts,
      callback: ({ val }) => {
        const goodResponse = !_.some(val, (part) => {
          return 'FAILED' === part.message;
        });
        if (goodResponse) {
          timeout.stop();
          this.set('parts', val);
        }
      },
    });

    app.api.realTime.listenOn({
      path: this.firebasePath.final,
      callback: ({ val }) => {
        timeout.stop();
        if ('DONE' === val.message) {
          this.markFinished();
        } else {
          this.markFailed(`final channel ${val.message}`);
        }
      },
    });
  }

  stopListenToUpdates() {
    app.api.realTime.cancelListen(this.firebasePath.parts);
    app.api.realTime.cancelListen(this.firebasePath.final);
  }

  reportFinish() {
    app.analytics('analytics:timeline:playedPreview', {
      'Timeline Type': app.rootStore.getters.hasAudioOnTimeline
        ? 'Text'
        : 'Time',
      'Video Length':
        app.rootStore.state?.story?.finalStoryDuration || 'unknown',
      'Response Time': this.time.finish - this.time.start,
    });
  }

  reportDataReuse() {
    app.analytics('analytics:timeline:playedPreviewCache', {
      'Timeline Type': app.rootStore.getters.hasAudioOnTimeline
        ? 'Text'
        : 'Time',
      'Video Length':
        app.rootStore.state?.story?.finalStoryDuration || 'unknown',
    });
  }
}

export default class Service extends IService {
  constructor() {
    super();
    this.currentJob = null;
  }

  checkout(story, previewVideoUrl) {
    this.remove(previewVideoUrl);

    if (_.isEmpty(this.currentJob)) {
      this.currentJob = new JobCarrier({}, { story: story });
      this._post(this.currentJob);
    } else {
      this.currentJob.reportDataReuse();
    }

    return this.currentJob;
  }

  remove(previewVideoUrl) {
    if (
      this.currentJob &&
      this.currentJob.id !== null &&
      !previewVideoUrl &&
      this.currentJob.id !== previewVideoUrl
    ) {
      this.currentJob.stopListenToUpdates();
      this.currentJob.stopListening();
      if (!this.currentJob.isDone) {
        this._cancelPreview();
      }
      this.currentJob = null;
    }
  }

  _post(job) {
    job.start();
    const postData = job.story.serialize();

    if (app.xhrExpected(this.$ajax)) {
      this.$ajax.abort();
    }
    this.$ajax = $.ajax({
      url: app.apiUrl(`/api/v1/draftStories/${postData.id}/previews`),
      type: 'POST',
      timeout: 2 * app.TIME.MINUTE,

      contentType: 'application/json',
      data: JSON.stringify(postData),

      error: (jqXHR, textStatus) => {
        job.markFailed(`post ajax error ${textStatus}`);
      },

      success: (response) => {
        if (
          response &&
          response.previewResultData &&
          response.previewResultData.cdnUrl
        ) {
          job.story.persistPreviewVideoData(postData);
          job.set(response.previewResultData);
          job.listenToUpdates();
        } else {
          job.markFailed('post ajax bad data');
        }
      },
    }).always(() => {
      this.$ajax = null;
    });
  }

  _cancelPreview() {
    const storyId = this.currentJob.story.id;
    const previewId = this.currentJob.get('previewId');

    $.ajax({
      url: app.apiUrl(`/api/v1/draftStories/${storyId}/previews/${previewId}`),
      type: 'DELETE',
    });
  }
}
